<template>
  <div id="voucher-add-update-new-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie  v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row :gutter="30" v-else key="content-loading">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-button-group class="d-flex flex-row">
                  <el-button round size="mini" class="w-100" :type="type == 0 ? 'primary' : 'default'" @click="type = 0">
                    <span :class="{'text-danger': validationErrors.some((x) => !x.key.includes('Tr'))}">{{$t('components.automatedmessages.voucherAddUpdate.defaultEn')}}</span>
                  </el-button>
                  <el-button round size="mini" class="w-100" :type="type == 1 ? 'primary' : 'default'" @click="type = 1">
                    <span :class="{'text-danger': validationErrors.some((x) => x.key.includes('Tr'))}">{{$t('components.automatedmessages.voucherAddUpdate.tr')}}</span>
                  </el-button>
                </el-button-group>
              </el-col>
              <el-col :span="24" class="mt-3 english" v-if="type == 0">
                <el-col :span="24" v-if="form.type == 0">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.title')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.titleMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('title', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.replyEmail')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.replyEmailMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.replyEmailAddress" :class="$inputError('replyEmailAddress', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('replyEmailAddress', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.subject')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.subjectMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.subject" :class="$inputError('subject', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('subject', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.variables')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.variablesMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>

                    <el-select v-model="addedObj" filterable v-if="groups.length > 0 ">
                      <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                        <el-option v-for="item in dynamicParams.filter((x) => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.message')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.messageMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.message" />
                    <span class="error">{{ $errorMessage('message', validationErrors) }}</span>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="24" class="mt-3 turkish" v-if="type == 1">
                <el-col :span="24">
                  <div class="registerform-input-container" v-if="form.type == 0">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.title')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.titleMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.titleTr" :class="$inputError('titleTr', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('titleTr', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.replyEmail')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.replyEmailMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.replyEmailAddressTr" :class="$inputError('replyEmailAddressTr', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('replyEmailAddressTr', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.subject')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.subjectMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.subjectTr" :class="$inputError('subjectTr', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage('subjectTr', validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.variables')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.variablesMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                 
                    <el-select v-model="addedObj2" filterable v-if="groups.length > 0 ">
                      <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                        <el-option v-for="item in dynamicParams.filter((x) => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{$t('components.automatedmessages.voucherAddUpdate.message')}}</label>
                        <el-tooltip :content="$t('components.automatedmessages.voucherAddUpdate.messageMsg')" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <quill-editor ref="myQuillEditor2" @ready="onEditorReady($event)" :options="editorOption" v-model="form.messageTr" />
                    <span class="error">{{ $errorMessage('messageTr', validationErrors) }}</span>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="24" class="mt-2">
                <el-row :gutter="10">
                  <el-col class="mt-2" :span="24">
                    <div class="custom-section-container">
                      <div class="section-header" @click="settingsDock = !settingsDock">
                        <div class="section-title">
                          <div class="section-head">
                            <label>{{$t('components.automatedmessages.voucherAddUpdate.settings')}}</label>
                            <!-- <el-tooltip content="Content" placement="bottom">
                            <i class="el-icon-info"></i>
                          </el-tooltip> -->
                          </div>
                          <span>{{$t('components.automatedmessages.voucherAddUpdate.settingsMsg')}}</span>
                        </div>
                        <div class="section-accordion">
                          <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                        </div>
                      </div>
                      <transition name="el-zoom-in-top">
                        <div class="section-wrapper" v-show="settingsDock">
                          <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.show')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span>{{$t('components.automatedmessages.voucherAddUpdate.showMsg')}}</span>
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.isActive"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showOnMenus ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showOnMenus ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.submission')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span>{{$t('components.automatedmessages.voucherAddUpdate.submissionMsg')}}</span>
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showOnMenus"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showQrCode ? 'sactive' : 'spassive'" v-if="form.category == 0 || form.category == 4">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showQrCode ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showQr')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span>{{$t('components.automatedmessages.voucherAddUpdate.showQrMsg')}}</span>
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showQrCode"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showEventLocation ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showEventLocation ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showLocation')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span
                                  >{{$t('components.automatedmessages.voucherAddUpdate.showLocationMsg')}}</span
                                >
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showEventLocation"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showMobileApplicationDownloadLinks ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showMobileApplicationDownloadLinks ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showMobileDownload')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span
                                  >{{$t('components.automatedmessages.voucherAddUpdate.showMobileDownloadMsg')}}</span
                                >
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showMobileApplicationDownloadLinks"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showWebLinks ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showWebLinks ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showWebLogin')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span
                                  >{{$t('components.automatedmessages.voucherAddUpdate.showWebLoginMsg')}}</span
                                >
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showWebLinks"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showParticipantActivationCode ? 'sactive' : 'spassive'" v-if="form.category == 0 || form.category == 4">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showParticipantActivationCode ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showActivation')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span
                                  >{{$t('components.automatedmessages.voucherAddUpdate.showActivationMsg')}}</span
                                >
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showParticipantActivationCode"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showFastLogins ? 'sactive' : 'spassive'"  v-if="form.category == 0 || form.category == 4">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showFastLogins ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showQuicklogin')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span>{{$t('components.automatedmessages.voucherAddUpdate.showQuickloginMsg')}}</span>
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showFastLogins"></el-switch>
                            </div>
                          </div>
                          <div class="custom-set-container" :class="form.showOrganizer ? 'sactive' : 'spassive'">
                            <div class="custom-set-inner">
                              <i class="fa" :class="form.showOrganizer ? 'fa-eye' : 'fa-eye-slash'"></i>
                              <div class="custom-set-info">
                                <label>
                                  {{$t('components.automatedmessages.voucherAddUpdate.showOrganizerInfo')}}
                                  <!-- <el-tooltip content="Content" placement="bottom">
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </label>
                                <span>{{$t('components.automatedmessages.voucherAddUpdate.showOrganizerInfoMsg')}}</span>
                              </div>
                            </div>
                            <div class="custom-set-actions fend">
                              <el-switch v-model="form.showOrganizer"></el-switch>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{$t('components.automatedmessages.voucherAddUpdate.close')}}</el-button>
        <template v-if="form.id && form.category == 0">
          <el-popconfirm
            @confirm="deleteItem"
            :confirmButtonText="$t('event.variables.yes')"
            :cancelButtonText="$t('event.buttons.cancel')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('event.textbox.toDelete')"
          >
            <el-button slot="reference" type="danger" icon="fas fa-trash" v-if="form.id && form.category == 0">{{$t('components.automatedmessages.voucherAddUpdate.delete')}}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{$t('components.automatedmessages.voucherAddUpdate.save')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {quillEditor} from 'vue-quill-editor';
  import axios from 'axios';
  export default {
    props: ['id'],
    components: {quillEditor},
    data() {
      return {
        axios,
        groups: [],
        settingsDock: false,
        validationErrors: [],
        type: 0,
        form: null,
        addedObj: null,
        addedObj2: null,
        variables: [],
        loading: false,
        timeout: null,
        listShort: null,
        editorOption: {
          modules: {
            toolbar: [['bold', 'italic', 'underline', 'strike'], [{color: []}, {background: []}], ['clean'], ['link', 'image']],
            syntax: {
              highlight: (text) => hljs.highlightAuto(text).value,
            },
          },
        },
      };
    },
    methods: {
      deleteItem() {
        this.$emit('deleteMe', this.form.id);
        this.$emit('closeDialog');
      },
      onEditorReady(editor) {
        editor.root.setAttribute('data-placeholder', this.$t('enterText'));
        editor.getModule('toolbar').addHandler('image', () => {
          this.selectLocalImage(editor);
        });
      },
      selectLocalImage(editor) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = () => {
          const file = input.files[0];
          if (/^image\//.test(file.type)) {
            this.saveToServer(file, editor);
            this.quillUploading = 'Image upload process started.';
          } else {
            //console.warn("You could only upload images.");
            this.quillUploading = 'You could only upload images.';
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        };
      },
      saveToServer(file, editor) {
        const fd = new FormData();

        fd.append('image', file);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', axios.defaults.baseURL + 'event/uploadImage?uploadType=html&language=' + this.$i18n.locale, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));

        xhr.onload = () => {
          if (xhr.status === 200) {
            const body = JSON.parse(xhr.responseText);
            if (body.alert.hasError == false) {
              const url = body.data.item.url;
              this.insertToEditor(url, editor);
              this.quillUploading = 'Image upload process completed successfully.';
              setTimeout(() => {
                this.quillUploading = false;
              }, 3000);
            } else {
              this.$message.error(body.alert.message);
              this.quillUploading = body.alert.message;
              setTimeout(() => {
                this.quillUploading = false;
              }, 3000);
            }
          } else {
            this.quillUploading = xhr.statusText + ' (Code: ' + xhr.status + ')';
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        };

        xhr.send(fd);
      },
      insertToEditor(url, editor) {
        editor.insertEmbed(editor.getSelection().index, 'image', url);
      },
      async save() {
        this.loading = 'save';
        if (this.listShort != null) clearTimeout(this.listShort);
        this.listShort = setTimeout(async () => {
          var res = await this.$store.dispatch('addUpdateVoucher', this.form);
          this.validationErrors = res.data.validationErrors;
          if (!res.data.alert.hasError) {
            this.form = res.data.data.item;
            await this.$store.dispatch('getAutomatedMessagesList');
          }
          this.loading = false;
        }, 500);
      },
    },
    async created() {
      this.loading = 'updateScreenLoading';
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.id != null && this.id != undefined) {
          var res = await this.$store.dispatch('getAutomatedMessage', this.id);
          if (!res.data.alert.hasError) {
            this.form = res.data.data.item;
          }
        } else {
          this.form = {
            id: null,
            title: null,
            titleTr: null,
            isActive: true,
            subject: null,
            subjectTr: null,
            replyEmailAddress: null,
            replyEmailAddressTr: null,
            message: null,
            messageTr: null,
            showEventLocation: true,
            showMobileApplicationDownloadLinks: true,
            showParticipantActivationCode: true,
            showQrCode: true,
            showOnMenus: true,
            showWebLinks: true,
            showOrganizer: true,
            type: 0,
            showFastLogins: true,
          };
        }
        await this.$store.dispatch('getDynamicParams', {type: this.form.type, isPrintScheme: false});
        this.groups = this.dynamicParams.map((x) => {
          return x.group;
        });
        this.groups = [...new Set(this.groups)];
        this.loading = false;
      }, 500);
    },
    computed: {
      dynamicParams() {
        return this.$store.getters.getDynamicParams;
      },
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
      editor2() {
        return this.$refs.myQuillEditor2.quill;
      },
    },
    watch: {
      addedObj: function() {
        if (this.addedObj != null) {
          var selection = this.editor.theme.quill.getSelection();
          var index;
          if (selection == null) {
            index = this.form.message != null ? this.form.message.length : 0;
          } else {
            index = selection;
          }
          this.editor.theme.quill.insertText(index, this.addedObj);
          this.addedObj = null;
        }
      },
      addedObj2: function() {
        if (this.addedObj2 != null) {
          var selection = this.editor2.theme.quill.getSelection();
          var index;
          if (selection == null) {
            index = this.form.message != null ? this.form.message.length : 0;
          } else {
            index = selection;
          }
          this.editor2.theme.quill.insertText(index, this.addedObj2);
          this.addedObj2 = null;
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .registerform-input-container {
    .el-upload {
      width: 100% !important;
    }
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      i {
        cursor: pointer;
      }
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem;
      gap: 0.3rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/automatedmessages/VoucherAddUpdate.vue